import type { FC, ReactElement } from 'react';
import { GlobalStateContext } from './GlobalStateModel';
import { useGlobalState } from './useGlobalState';

interface Props {
  children: ReactElement;
}

export const GlobalState: FC<Props> = (props) => {
  const globalState = useGlobalState();

  return (
    <GlobalStateContext.Provider value={globalState}>
      {props.children}
    </GlobalStateContext.Provider>
  );
};
